import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'

export const fieldReportInfoSchema = yup.object({
  field_impression: yup.string().required(),
  round_impression: yup.string().required(),
  photos: mediaSchema,
})
